import { FilterProps } from '../shared';
import { SelectInput } from '@coverright/ui/inputs';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { AvailableStateDto } from '@coverright/data-access/types/medicare';
import React from 'react';

export const StateFilter = ({ value, onChange }: FilterProps<string>) => (
  <SelectInput label={'State'}
               hideTick
               value={value}
               onChange={event => {
                 onChange(event.target.value as string);
               }}>
    <MenuItem value={''}>-</MenuItem>
    {Object.values(AvailableStateDto).sort().map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
  </SelectInput>
);
